"use client";
import "../chunk-N3ETBM74.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { AccountIcon } from "@dfds-frontend/navigator-icons/icons";
import { useEffect, useId, useRef, useState } from "react";
import { getLoginBadgeContent } from "./content";
import { LoginMenu } from "./LoginMenu";
const LoginBadge = ({ avatarInitial, locale, useDarkMode, useDarkModeLg }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuId = useId();
  const ref = useRef(null);
  const content = getLoginBadgeContent(locale);
  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setIsOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "relative select-none", ref, children: [
    /* @__PURE__ */ jsx(
      "button",
      {
        "aria-controls": isOpen ? menuId : void 0,
        "aria-expanded": isOpen,
        "aria-haspopup": "menu",
        "aria-label": content.myProfile,
        className: `group bg-transparent text-semantic-global-text-default hover:bg-semantic-global-background-light-grey hover:text-semantic-global-primary-default active:bg-semantic-global-background-light-grey active:text-semantic-global-primary-default focus-visible:bg-semantic-global-background-light-grey focus-visible:text-semantic-global-primary-default flex h-[36px] w-[36px] min-[400px]:h-[44px] min-[400px]:w-[44px] cursor-pointer items-center justify-center border-0 ${useDarkMode ? "hover:!bg-transparent active:!bg-transparent focus-visible:!bg-transparent" : useDarkModeLg ? "lg:hover:!bg-transparent lg:active:!bg-transparent lg:focus-visible:!bg-transparent" : ""}`,
        "data-e2e-loggedin": !!avatarInitial,
        id: "login-badge",
        onClick: () => setIsOpen((open) => !open),
        type: "button",
        children: avatarInitial ? /* @__PURE__ */ jsx(
          "span",
          {
            className: `font-primitive-dfds-sans font-primitive-regular flex size-6 shrink-0 items-center justify-center rounded-full bg-semantic-global-primary-darkest p-0 text-primitive-12 leading-none text-semantic-global-text-lightest ${useDarkMode ? "!bg-semantic-global-background-white !text-semantic-global-primary-darkest" : ""} ${useDarkModeLg ? "lg:bg-semantic-global-background-white lg:text-semantic-global-primary-darkest" : ""}`,
            children: avatarInitial == null ? void 0 : avatarInitial.toUpperCase()
          }
        ) : /* @__PURE__ */ jsx(
          AccountIcon,
          {
            "data-e2e": "login-badge-account-icon",
            className: `size-[20px] text-semantic-global-primary-darkest group-hover:text-semantic-global-primary-default group-active:text-semantic-global-primary-default group-focus-visible:text-semantic-global-primary-default ${useDarkMode ? "!text-semantic-global-text-lightest group-hover:!text-semantic-global-primary-default group-active:!text-semantic-global-primary-default group-focus-visible:!text-semantic-global-primary-default" : useDarkModeLg ? "lg:!text-semantic-global-text-lightest lg:group-hover:!text-semantic-global-primary-default lg:group-active:!text-semantic-global-primary-default lg:group-focus-visible:!text-semantic-global-primary-default" : ""}`,
            size: "md"
          }
        )
      }
    ),
    isOpen ? /* @__PURE__ */ jsx(LoginMenu, { content, id: menuId, isLoggedIn: !!avatarInitial, locale }) : null
  ] });
};
export {
  LoginBadge
};
